import { useEffect, useState } from "react";
import { getFiscalYearStartDate } from "../functions/deducation";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { ORDER_CANCELLED } from "../constants/orderStatus";

// 購入依頼者の今期の購入実績(カテゴリ別数量)をリアルタイムに集計するフック。
//
// 旧実装は orders コレクション全件を購読し、誰かの注文のたびに全体を再クエリ
// していたため、読み取り課金の増大と「計算中…」のチラつきが発生していた。
// ここでは getOrdersFromFiscalYearStart と同一条件(購入依頼者・今期・取消済以外)に
// 絞った購読1本とし、スナップショットから直接集計する(複合インデックスは既存)。
export const useCategoryCounts = (billingUserId, billingUserName) => {
  const { dateObj: firstDate, dateString } = getFiscalYearStartDate();
  const [categoryCounts, setCategoryCounts] = useState([]);

  useEffect(() => {
    // billingUserIdが未設定の場合はリスナーを登録しない
    if (!billingUserId || !billingUserName) {
      setCategoryCounts([]);
      return;
    }
    const q = query(
      collection(db, "orders"),
      where("placed_at", ">=", firstDate), // placed_atが期の初日以降
      where("status", "!=", ORDER_CANCELLED), // statusが"取消済"以外
      where("billing_user_id", "==", Number(billingUserId)) // 購入依頼者が一致
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        // カテゴリIDごとにquantityを集計する
        const categoryTotals = {};
        snapshot.docs.forEach((orderDoc) => {
          const { category_id, quantity } = orderDoc.data();
          // 旧データにquantityが文字列で入っていても数値として集計する
          categoryTotals[category_id] =
            (categoryTotals[category_id] || 0) + Number(quantity);
        });
        const result = Object.keys(categoryTotals).map((category_id) => ({
          category_id,
          quantity: categoryTotals[category_id],
        }));
        setCategoryCounts(result);
      },
      (error) => {
        console.error("購入実績の取得に失敗しました:", error);
        setCategoryCounts([]);
      }
    );

    // billingUserIdが変わった場合やアンマウント時にリスナーを解除
    return () => unsubscribe();
    // firstDateはdateStringと1:1で決まるため、depsはdateStringで代表する
  }, [billingUserId, billingUserName, dateString]);

  return { categoryCounts };
};
